import * as yup from 'yup'

export const validateEmail = (st: string): boolean => {
  const schema = yup.string().email().required()
  try {
    schema.validateSync(st)
    return true
  } catch(e) {
    return false
  }
}